// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailD":"D_d2xDetailD__NvJsv"};